module.exports = __webpack_public_path__ + "img/tencent-active.87267f39.jpg";